export const state = {
  reportParameters: [],
  entitiesStructure:[]
}
export const mutations = {
  removeParameter(state, payload) {
    let findIndex = state.reportParameters.findIndex(
      (p) => p.key === payload.key
    );
    if (findIndex > -1) 
      state.reportParameters.splice(findIndex, 1);
  },
  saveOrUpdateParameter(state, payload) {
    let findIndex = state.reportParameters.findIndex(
      (p) => p.key === payload.key
    );
    if (findIndex > -1) 
      state.reportParameters[findIndex] = payload
    else
      state.reportParameters.push(payload)
  },
  setReportParameters(state, payload) {
    state.reportParameters = payload
  },
  setEntitiesStructure(state, payload) {
    state.entitiesStructure = payload
  }
}
export const actions = {
  removeParameter({ commit }, payload) {
    commit('removeParameter', payload)
  },
  saveOrUpdateParameter({commit}, payload){
    commit('saveOrUpdateParameter', payload)
  },
  setReportParameters({commit}, payload){
    commit('setReportParameters', payload)
  },
  setEntitiesStructure({commit}, payload){
    commit('setEntitiesStructure', payload)
  }
}
export const getters = {
  entitiesStructure: state => {
    return state.entitiesStructure
  },
  reportParameters: state => {
    return state.reportParameters
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
